import React from 'react';
import { motion } from 'framer-motion';
import { HiCode, HiDatabase, HiDeviceMobile } from 'react-icons/hi';

const services = [
  {
    icon: HiCode,
    title: 'Software sob medida de verdade',
    description: 'Modelamos o processo do seu negócio antes de desenhar a interface. O sistema nasce para a rotina real, não para forçar adaptação da equipe.',
    color: '#3B9ED4',
    step: '01',
  },
  {
    icon: HiDatabase,
    title: 'Integração e menos retrabalho',
    description: 'Conectamos fiscal, financeiro, cadastros e operação para reduzir digitação duplicada e dar rastreabilidade ao fluxo de ponta a ponta.',
    color: '#2178AB',
    step: '02',
  },
  {
    icon: HiDeviceMobile,
    title: 'Web e mobile com foco operacional',
    description: 'Desenvolvemos plataformas para times que precisam agilidade, previsibilidade e experiência clara em desktop e celular.',
    color: '#5BACD1',
    step: '03',
  },
];

const containerVariant = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      staggerChildren: 0.1,
    },
  },
};

const itemVariant = {
  hidden: { opacity: 0, y: 18 },
  visible: { opacity: 1, y: 0 },
};

function Services() {
  return (
    <section id="services" className="section-padding" style={{ background: '#FAFEFF' }}>
      <div className="container">
        <motion.div
          className="section-header text-center"
          variants={containerVariant}
          initial="hidden"
          animate="visible"
        >
          <motion.p
            variants={itemVariant}
            style={{
              display: 'inline-flex',
              padding: '8px 14px',
              borderRadius: '9999px',
              background: 'rgba(59,158,212,0.08)',
              color: '#2178AB',
              fontWeight: 700,
              marginBottom: '18px',
            }}
          >
            Como trabalhamos
          </motion.p>
          <motion.h2 variants={itemVariant} className="section-title">
            Processo claro, entrega útil e código que aguenta operação.
          </motion.h2>
          <motion.p variants={itemVariant} style={{ maxWidth: '700px', margin: '0 auto 46px', color: '#4A6680' }}>
            Nosso trabalho combina leitura de negócio, desenho de fluxo e implementação prática para o sistema fazer sentido no uso diário.
          </motion.p>
        </motion.div>

        <motion.div
          className="row"
          variants={containerVariant}
          initial="hidden"
          animate="visible"
        >
          {services.map((service) => {
            const Icon = service.icon;

            return (
              <div key={service.title} className="col-md-6 col-lg-4 col-xs-12">
                <motion.article
                  className="services-item"
                  variants={itemVariant}
                  whileHover={{ y: -8, boxShadow: `0 22px 50px ${service.color}20` }}
                  transition={{ duration: 0.24 }}
                  style={{
                    background: 'linear-gradient(145deg, rgba(255,255,255,0.98) 0%, rgba(235,246,252,0.92) 100%)',
                    border: '1px solid rgba(59,158,212,0.14)',
                    borderRadius: '26px',
                    boxShadow: '0 10px 30px rgba(59,158,212,0.08)',
                    position: 'relative',
                    overflow: 'hidden',
                    textAlign: 'left',
                    cursor: 'default',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      top: '18px',
                      right: '18px',
                      color: 'rgba(33,120,171,0.28)',
                      fontWeight: 800,
                      fontSize: '0.95rem',
                      letterSpacing: '0.08em',
                    }}
                  >
                    {service.step}
                  </div>

                  <div
                    className="icon"
                    style={{
                      width: '68px',
                      height: '68px',
                      borderRadius: '20px',
                      background: `linear-gradient(135deg, ${service.color} 0%, #A8D8F0 100%)`,
                      boxShadow: `0 12px 24px ${service.color}22`,
                      marginBottom: '24px',
                    }}
                  >
                    <Icon size={34} color="#fff" />
                  </div>

                  <div className="services-content">
                    <h3 style={{ color: '#1A2D3A', marginBottom: '14px' }}>{service.title}</h3>
                    <p style={{ color: '#5A7A8E', lineHeight: 1.75 }}>{service.description}</p>
                  </div>
                </motion.article>
              </div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}

export default Services;
